import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=7343dbb8&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=7343dbb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7343dbb8",
  null
  
)

export default component.exports